var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatEndSessionIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9710_47107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.9292 10.9379V89.0612C65.9292 90.6784 64.6167 91.9909 62.9995 91.9909H44.2499C42.6328 91.9909 41.3203 90.6784 41.3203 89.0612V10.9379C41.3203 9.32077 42.6328 8.0083 44.2499 8.0083H62.9995C64.6167 8.0083 65.9292 9.32077 65.9292 10.9379Z",
    fill: "#58280A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9292 49.9998V89.0614C65.9292 90.6786 64.6167 91.991 62.9995 91.991H44.2499C42.6328 91.991 41.3203 90.6786 41.3203 89.0614V49.9998H65.9292Z",
    fill: "#4F2204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6296 52.0816L80.6847 70.8312C78.8461 72.657 75.6946 71.3501 75.6946 68.7492V62.3041H44.2499C42.6328 62.3041 41.3203 60.9916 41.3203 59.3744V40.6248C41.3203 39.0077 42.6328 37.6952 44.2499 37.6952H75.6946V31.25C75.6946 28.6522 78.8414 27.3419 80.6847 29.168L99.6296 47.9176C100.788 49.0637 100.788 50.9348 99.6296 52.0816Z",
    fill: "#D3AE73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.499 49.9998C100.499 50.7829 100.186 51.531 99.6296 52.0817L80.6847 70.8313C78.8461 72.6571 75.6946 71.3503 75.6946 68.7494V62.3042H44.2499C42.6328 62.3042 41.3203 60.9917 41.3203 59.3746V49.9998H100.499Z",
    fill: "#BA955B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2511 2.93042V97.069L3.43164 89.0614V10.9381L44.2511 2.93042Z",
    fill: "#743E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2511 49.9998V97.0691L3.43164 89.0614V49.9998H44.2511Z",
    fill: "#6B3715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6866 0.0554644C30.5822 2.62631 16.0434 5.4782 2.86714 8.06311C1.49412 8.33263 0.501953 9.53768 0.501953 10.938V89.0614C0.501953 90.4617 1.49412 91.6668 2.86714 91.9363C12.9615 93.9165 37.2588 98.6828 43.6866 99.9439C45.4885 100.3 47.1806 98.9141 47.1806 97.069V2.9304C47.1806 1.10095 45.5098 -0.300192 43.6866 0.0554644ZM41.3214 93.5085L19.0562 89.1414V10.858L41.3214 6.49087V93.5085Z",
    fill: "#6A3411"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1806 49.9998V97.0691C47.1806 98.9136 45.4893 100.301 43.6866 99.944C37.3252 98.696 12.9036 93.9053 2.86714 91.9364C1.49412 91.6668 0.501953 90.4618 0.501953 89.0614V49.9998H19.0562V89.1415L41.3214 93.5086V49.9998H47.1806Z",
    fill: "#582809"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6796 46.8747V53.1246C34.6796 54.7417 33.3671 56.0542 31.7499 56.0542C30.1328 56.0542 28.8203 54.7417 28.8203 53.1246V46.8747C28.8203 45.2575 30.1328 43.9451 31.7499 43.9451C33.3671 43.9451 34.6796 45.2575 34.6796 46.8747Z",
    fill: "#CAA084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6797 49.9998V53.1248C34.6797 54.7419 33.3672 56.0544 31.75 56.0544C30.1328 56.0544 28.8203 54.7419 28.8203 53.1248V49.9998H34.6797Z",
    fill: "#D09B77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9710_47107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEndSessionIllustration);
export default __webpack_public_path__ + "static/media/chat-end-session-illustration.6d18742f71e132946c91a2866c1f08bd.svg";
export { ForwardRef as ReactComponent };